import { QUERY_KEYS } from '@forwardflow/helpers/utils'
import { FubService } from '@forwardflow/services/fub.service'
import useSWR from 'swr'

export const useFubPeopleSources = (
   orgId: string,
   page: number,
   limit: number,
   isFUBConnected: boolean,
   search?: string
) => {
   return useSWR(
      orgId && isFUBConnected
         ? [QUERY_KEYS.GET_PEOPLE_SOURCES, orgId, page, limit, isFUBConnected, search]
         : null,
      () => FubService.getPeopleSources({ orgId, page, limit, search }),
      {
         revalidateOnFocus: false,
         revalidateOnReconnect: true,
         dedupingInterval: 5000,
      }
   )
}

export const useFubPonds = (
   orgId: string,
   page: number,
   limit: number,
   isFUBConnected: boolean,
   search?: string
) => {
   return useSWR(
      orgId && isFUBConnected
         ? [QUERY_KEYS.GET_FUB_PONDS, orgId, page, limit, isFUBConnected, search]
         : null,
      () => FubService.getPonds({ orgId, page, limit, search }),
      {
         revalidateOnFocus: false,
         revalidateOnReconnect: true,
         dedupingInterval: 5000,
      }
   )
}
